import { PreviewStatementDatasetSource } from "../previewTypes";

export const PROFIT_LOSS_DATASET: PreviewStatementDatasetSource = {
    shape: "statement",
    accountHeader: "Account",
    percentHeader: "% of income",
    percentBase: 2200000,
    rows: [
        { id: "income", label: "Income", kind: "section" },
        { id: "revenue", label: "Revenue", kind: "line", amount: 2200000 },
        {
            id: "total-income",
            label: "Total Income",
            kind: "total",
            amount: 2200000,
            hasTopBorder: true,
        },
        {
            id: "cogs",
            label: "Cost of Goods Sold",
            kind: "total",
            amount: 740000,
            hasTopBorder: true,
        },
        {
            id: "gross-profit",
            label: "Gross Profit",
            kind: "total",
            amount: 1460000,
        },
        { id: "expenses", label: "Expenses", kind: "section" },
        {
            id: "payroll",
            label: "Payroll and Wages",
            kind: "line",
            amount: 1012000,
        },
        {
            id: "depreciation",
            label: "Depreciation Expense",
            kind: "line",
            amount: 120000,
        },
        {
            id: "contract-labor",
            label: "Contract Labor",
            kind: "line",
            amount: 296400,
        },
        {
            id: "insurance",
            label: "Insurance - Business",
            kind: "line",
            amount: 48200,
        },
        {
            id: "facilities",
            label: "Facilities - Repairs and Maintenance",
            kind: "line",
            amount: 139475,
        },
        {
            id: "advertising",
            label: "Advertising and Marketing",
            kind: "line",
            amount: 0,
            hasActivity: true,
        },
        {
            id: "bad-debt",
            label: "Bad Debt Expense",
            kind: "line",
            amount: 0,
        },
        {
            id: "total-expenses",
            label: "Total Expenses",
            kind: "total",
            amount: 1616075,
            hasTopBorder: true,
        },
        {
            id: "net-operating-income",
            label: "Net Operating Income",
            kind: "total",
            amount: -156075,
        },
        {
            id: "other-income-line",
            label: "Other Income",
            kind: "line",
            amount: 62403.42,
        },
        {
            id: "net-income",
            label: "Net Income",
            kind: "total",
            amount: -93671.58,
        },
    ],
};
